import React, { useState, useEffect } from "react";

import axiosInstance from "../../../api/axios.instance";

import { useForm } from "@mantine/form";

import clsx from "clsx";

import {
  TextInput,
  Select,
  NumberInput,
  Button,
  Checkbox,
  Grid,
  Tooltip,
  Loader,
  Group,
  Text,
  Switch,
} from "@mantine/core";
import { IoClose } from "react-icons/io5";

import styles from "./styles.module.scss";
import w from "./workerForm.module.scss";

import ToastWarning from "../../../toast/components/toastWarning/ToastWarning";

import toast from "react-hot-toast";
import { modals } from "@mantine/modals";

const ROLE_GROUPS = [
  ["researcher", "Researcher"],
  ["stringer", "Stringer"],
  ["editor", "Editor"],
  ["output editor", "Output editor"],
  ["gallery editor", "Gallery editor"],
  ["copyright manager", "Copyright manager"],
  ["admin", "Admin"],
  ["observer", "Observer"],
];
const initialsOf = (s) =>
  String(s || "?")
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((x) => x[0])
    .join("")
    .toUpperCase();

const UserInfoModal = ({ context, id, innerProps }) => {
  const userDataForm = useForm({
    initialValues: {
      name: "",
      email: "",
      ...(innerProps?.mode !== "edit" && {
        password: "",
      }),
      nickname: "",
      role: innerProps?.role || "",
      position: "",
      percentage: 0,
      advancePayment: 0,
      advancePaymentNonExclusive: 0,
      baseSalary: 0,
      videoRate: 0,
      country: "",
      telegramId: "",
      paymentMethod: "",
      canBeAssigned: false,
      displayOnTheSite: false,
      videoPool: true,
      mainInstagramPage: false,
      canSeeAllVideosInTrello: true,
      nonExclusiveAcquisitionIsAllowed: true,
      skipRights: false,
      skipRightsAnyLink: false,
      autoApproveNonExclusive: false,
      phoneBankTransfer: "",
      emailBankTransfer: "",
      addressBankTransfer: "",
      zipCodeBankTransfer: "",
      bankNameBankTransfer: "",
      fullNameBankTransfer: "",
      accountNumberBankTransfer: "",
      AdditionalInformation: "",
      payPalEmail: "",
      textFieldOther: "",
      stringerPaymentType: "",
      stringerPaymentValue: "",
      uplineResearcher: "",
      uplineResearcherComissionExclusive: 0,
      uplineResearcherComissionNonExclusive: 0,
    },

    validate: {
      email: (value) => (!value ? "Empty field" : null),
      name: (value) => (!value ? "Empty field" : null),
      role: (value) => (!value ? "Empty field" : null),
      nickname: (value) =>
        value.includes("@") ? 'Unnecessary character "@"' : null,
      phoneBankTransfer: (value) =>
        userDataForm.values.paymentMethod === "bankTransfer" && !value
          ? "Empty field"
          : null,
      emailBankTransfer: (value) =>
        userDataForm.values.paymentMethod === "bankTransfer" && !value
          ? "Empty field"
          : userDataForm.values.paymentMethod === "bankTransfer" &&
            !/^\S+@\S+$/.test(value)
          ? "Invalid email"
          : null,
      addressBankTransfer: (value) =>
        userDataForm.values.paymentMethod === "bankTransfer" && !value
          ? "Empty field"
          : null,
      zipCodeBankTransfer: (value) =>
        userDataForm.values.paymentMethod === "bankTransfer" && !value
          ? "Empty field"
          : null,
      bankNameBankTransfer: (value) =>
        userDataForm.values.paymentMethod === "bankTransfer" && !value
          ? "Empty field"
          : null,
      fullNameBankTransfer: (value) =>
        userDataForm.values.paymentMethod === "bankTransfer" && !value
          ? "Empty field"
          : null,
      accountNumberBankTransfer: (value) =>
        userDataForm.values.paymentMethod === "bankTransfer" && !value
          ? "Empty field"
          : null,
      payPalEmail: (value) =>
        userDataForm.values.paymentMethod === "payPal" && !value
          ? "Empty field"
          : userDataForm.values.paymentMethod === "payPal" &&
            !/^\S+@\S+$/.test(value)
          ? "Invalid email"
          : null,
      textFieldOther: (value) =>
        userDataForm.values.paymentMethod === "other" && !value
          ? "Empty field"
          : null,
      stringerPaymentType: (value) =>
        !!userDataForm.values.stringerPaymentValue && !value
          ? "Nothing is selected"
          : null,
      stringerPaymentValue: (value) =>
        !!userDataForm.values.stringerPaymentType && !value
          ? "Empty field"
          : null,
    },
  });

  const roleVariants = [
    { value: "researcher", label: "Researcher" },
    { value: "admin", label: "Admin" },
    { value: "editor", label: "Editor" },
    { value: "stringer", label: "Stringer" },
    { value: "observer", label: "Observer" },
    { value: "copyright manager", label: "Copyright Manager" },
    { value: "output editor", label: "Output Editor" },
    { value: "gallery editor", label: "Gallery Editor" },
  ];

  const paymentVariants = [
    {
      value: "bankTransfer",
      label: "Bank Transfer",
      disabled: false,
    },
    {
      value: "payPal",
      label: "PayPal",
      disabled: false,
    },
    { value: "other", label: "Other" },
  ];

  const [isLoading, setIsLoading] = useState(false);
  const [countries, setCountries] = useState([]);
  const [currentMonthSalary, setCurrentMonthSalary] = useState(null);
  const [isSalaryLoading, setIsSalaryLoading] = useState(false);
  const [researchers, setResearchers] = useState([]);
  
  // Fetch current month salary for editors, copyright managers, and output editors
  useEffect(() => {
    const fetchSalaryData = async () => {
      if (
        innerProps?.userData?._id && 
        (innerProps?.userData?.role === 'editor' || innerProps?.userData?.role === 'copyright manager' || innerProps?.userData?.role === 'output editor' || innerProps?.userData?.role === 'gallery editor')
      ) {
        setIsSalaryLoading(true);
        try {
          const { data } = await axiosInstance.get('/users/current-month-salary', {
            params: {
              userId: innerProps.userData._id,
              role: innerProps.userData.role
            }
          });
          setCurrentMonthSalary(data.apiData);
        } catch (error) {
          console.error('Error fetching salary data:', error);
        } finally {
          setIsSalaryLoading(false);
        }
      }
    };
    
    fetchSalaryData();
    
    // Set up interval to refresh data every minute
    const intervalId = setInterval(() => {
      fetchSalaryData();
    }, 60000);
    
    // Clean up interval on component unmount
    return () => clearInterval(intervalId);
  }, [innerProps?.userData?._id, innerProps?.userData?.role]);

  useEffect(() => {
    if (innerProps?.userData) {
      userDataForm.setValues({
        ...(innerProps?.userData.name && {
          name: innerProps?.userData.name,
        }),
        ...(innerProps?.userData.email && {
          email: innerProps?.userData.email,
        }),

        ...(innerProps?.userData.position && {
          position: innerProps?.userData.position,
        }),
        ...(innerProps?.userData.role && {
          role: innerProps?.userData.role,
        }),
        ...(innerProps?.userData.country && {
          country: innerProps?.userData.country,
        }),
        ...(innerProps?.userData.percentage && {
          percentage: innerProps?.userData.percentage,
        }),
        ...(innerProps?.userData.videoRate && {
          videoRate: innerProps?.userData.videoRate,
        }),
        ...(innerProps?.userData.baseSalary && {
          baseSalary: innerProps?.userData.baseSalary,
        }),
        ...(innerProps?.userData.telegramId && {
          telegramId: innerProps?.userData.telegramId,
        }),
        ...(innerProps?.userData.advancePayment && {
          advancePayment: innerProps?.userData.advancePayment,
        }),
        ...(innerProps?.userData.advancePaymentNonExclusive && {
          advancePaymentNonExclusive:
            innerProps?.userData.advancePaymentNonExclusive,
        }),
        ...(innerProps?.userData?.nickname && {
          nickname: innerProps.userData.nickname.replace("@", ""),
        }),
        ...(innerProps?.userData?.hasOwnProperty("paymentAsStringer") && {
          stringerPaymentType: innerProps.userData.paymentAsStringer.type,
          stringerPaymentValue: innerProps.userData.paymentAsStringer.amount,
        }),
        ...(innerProps?.userData?.paymentInfo?.variant && {
          ...(innerProps?.userData.paymentInfo.variant === "payPal" && {
            paymentMethod: innerProps?.userData?.paymentInfo?.variant,
            payPalEmail: innerProps?.userData?.paymentInfo?.payPalEmail,
          }),
          ...(innerProps?.userData.paymentInfo.variant === "bankTransfer" && {
            paymentMethod: innerProps?.userData.paymentInfo.variant,
            phoneBankTransfer: innerProps?.userData?.paymentInfo.phoneNumber,
            emailBankTransfer: innerProps?.userData.paymentInfo?.email,
            addressBankTransfer: innerProps?.userData.paymentInfo.address,
            zipCodeBankTransfer: innerProps?.userData.paymentInfo.zipCode,
            bankNameBankTransfer: innerProps?.userData.paymentInfo.bankName,
            fullNameBankTransfer: innerProps?.userData.paymentInfo.fullName,
            accountNumberBankTransfer: innerProps?.userData.paymentInfo.iban,
            AdditionalInformation:
              innerProps?.userData.paymentInfo.additionalInformation,
          }),
          ...(innerProps?.userData.paymentInfo.variant === "other" && {
            paymentMethod: innerProps?.userData?.paymentInfo?.variant,
            textFieldOther: innerProps?.userData?.paymentInfo?.value,
          }),
        }),

        ...(typeof innerProps?.userData.canBeAssigned === "boolean" && {
          canBeAssigned: innerProps?.userData.canBeAssigned,
        }),
        ...(typeof innerProps?.userData.displayOnTheSite === "boolean" && {
          displayOnTheSite: innerProps?.userData.displayOnTheSite,
        }),
        ...(typeof innerProps?.userData.videoPool === "boolean" && {
          videoPool: innerProps?.userData.videoPool,
        }),
        ...(typeof innerProps?.userData.mainInstagramPage === "boolean" && {
          mainInstagramPage: innerProps?.userData.mainInstagramPage,
        }),
        ...(typeof innerProps?.userData.canSeeAllVideosInTrello ===
          "boolean" && {
          canSeeAllVideosInTrello: innerProps?.userData.canSeeAllVideosInTrello,
        }),
        ...(typeof innerProps?.userData.nonExclusiveAcquisitionIsAllowed ===
          "boolean" && {
          nonExclusiveAcquisitionIsAllowed: innerProps?.userData.nonExclusiveAcquisitionIsAllowed,
        }),
        ...Object.fromEntries(
          ["skipRights", "skipRightsAnyLink", "autoApproveNonExclusive"]
            .filter((k) => typeof innerProps?.userData?.[k] === "boolean")
            .map((k) => [k, innerProps.userData[k]])
        ),
        ...(innerProps?.userData.uplineResearcher && {
          uplineResearcher: innerProps?.userData.uplineResearcher,
        }),
        ...(innerProps?.userData.uplineResearcherComissionExclusive && {
          uplineResearcherComissionExclusive: innerProps?.userData.uplineResearcherComissionExclusive,
        }),
        ...(innerProps?.userData.uplineResearcherComissionNonExclusive && {
          uplineResearcherComissionNonExclusive: innerProps?.userData.uplineResearcherComissionNonExclusive,
        }),
      });

      userDataForm.setValues({
        canSeeAllVideosInTrello: !!innerProps.userData.canSeeAllVideosInTrello,
      });
    }

    (async () => {
      try {
        const [countriesResponse, researchersResponse] = await Promise.all([
          axiosInstance.get("/location/getAllCountries"),
          axiosInstance.get("/users/getAll", {
            params: { roles: "researcher", fieldsInTheResponse: "_id,name" }
          })
        ]);

        setCountries(countriesResponse.data.apiData);
        setResearchers(researchersResponse.data.apiData.users.map(researcher => ({
          value: researcher._id,
          label: researcher.name
        })));
      } catch (err) {
        console.log(err);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [innerProps]);

  const toCreateOrUpdateUser = async (values) => {
    setIsLoading(true);
    try {
      let response;

      if (innerProps?.mode === "edit") {
        if (innerProps.role === "company") {
          const { data } = await axiosInstance.patch(
            `/companies/${innerProps?.userData._id}`,
            {
              email: values.email,
              name: values.name,
              percentage: values.percentage,
              ...(values.paymentMethod === "other" && {
                paymentInfo: {
                  variant: values.paymentMethod,
                  value: values.textFieldOther,
                },
              }),
              ...(values.paymentMethod === "bankTransfer" && {
                paymentInfo: {
                  variant: values.paymentMethod,
                  phoneNumber: values.phoneBankTransfer,
                  email: values.emailBankTransfer,
                  address: values.addressBankTransfer,
                  zipCode: values.zipCodeBankTransfer,
                  bankName: values.bankNameBankTransfer,
                  fullName: values.fullNameBankTransfer,
                  iban: values.accountNumberBankTransfer,
                  AdditionalInformation: values.AdditionalInformation,
                },
              }),
              ...(values.paymentMethod === "payPal" && {
                paymentInfo: {
                  variant: values.paymentMethod,
                  payPalEmail: values.payPalEmail,
                },
              }),
            }
          );
          response = data;
        } else {
          const { data } = await axiosInstance.patch(
            `/users/updateOne`,
            {
              ...values,
              ...(values.paymentMethod === "other" && {
                paymentInfo: {
                  paymentMethod: values.paymentMethod,
                  value: values.textFieldOther,
                },
              }),
              ...(values.paymentMethod === "bankTransfer" && {
                paymentInfo: {
                  paymentMethod: values.paymentMethod,
                  phoneNumber: values.phoneBankTransfer,
                  email: values.emailBankTransfer,
                  address: values.addressBankTransfer,
                  zipCode: values.zipCodeBankTransfer,
                  bankName: values.bankNameBankTransfer,
                  fullName: values.fullNameBankTransfer,
                  iban: values.accountNumberBankTransfer,
                },
              }),
              ...(values.paymentMethod === "payPal" && {
                paymentInfo: {
                  paymentMethod: values.paymentMethod,
                  payPalEmail: values.payPalEmail,
                },
              }),
            },

            {
              params: {
                userId: innerProps?.userData._id,
              },
            }
          );
          response = data;
        }
      } else {
        const url =
          innerProps.role === "company" ? `/companies` : `/users/createOne`;

        const { data } = await axiosInstance.post(url, values);
        response = data;
      }

      if (response.status === "warning") {
        return toast.custom(<ToastWarning text={response.message} />);
      } else {
        toast.success(response.message);

        userDataForm.reset();
        if (innerProps?.onTrigger) {
          innerProps.onTrigger();
        }

        modals.closeAll();
      }
    } catch (err) {
      console.log(err);

      toast.error(err.message || err.response.data.message);
    } finally {
      setIsLoading(false);
    }
  };

  // ── workers (not authors, not partner companies): VBear Admin design ──
  const role = userDataForm.values.role;
  const isWorker = innerProps?.role !== "company" && innerProps?.role !== "author" && role !== "author";
  const close = () => (context && id ? context.closeModal(id) : modals.closeAll());
  const toggle = (name, label, hint) => (
    <Switch
      key={name}
      className={w.switch}
      color="teal"
      label={
        <span className={w.switchLabel}>
          <b>{label}</b>
          {hint && <small>{hint}</small>}
        </span>
      }
      {...userDataForm.getInputProps(name, { type: "checkbox" })}
    />
  );
  const isStaffPay = role === "editor" || role === "copyright manager" || role === "output editor" || role === "gallery editor";

  if (isWorker) {
    const u = innerProps?.userData;
    return (
      <form className={w.vb} onSubmit={userDataForm.onSubmit((values) => toCreateOrUpdateUser(values))}>
        <div className={w.head}>
          {u?.avatarUrl ? <span className={w.avatar} style={{ backgroundImage: `url(${u.avatarUrl})` }} /> : <span className={w.avatar}>{initialsOf(userDataForm.values.name || "New")}</span>}
          <div>
            <b>{innerProps?.mode === "edit" ? userDataForm.values.name || "Edit worker" : "Add worker"}</b>
            <small>{innerProps?.mode === "edit" ? userDataForm.values.email : "A new member of the team gets a login with this email"}</small>
          </div>
          <button type="button" className={w.x} onClick={close} title="Close">
            <IoClose />
          </button>
        </div>

        <div className={w.body}>
          <section className={w.sec}>
            <h4>Role</h4>
            <div className={w.roles}>
              {ROLE_GROUPS.map(([k, label]) => (
                <button type="button" key={k} className={clsx(role === k && w.roleOn)} onClick={() => userDataForm.setFieldValue("role", k)}>
                  {label}
                </button>
              ))}
            </div>
            {userDataForm.errors.role && <span className={w.err}>Choose a role</span>}
            {innerProps?.userData?.extraRoles?.length > 0 && (
              <small className={w.note}>Also works as: {innerProps.userData.extraRoles.join(", ")} (switch in the profile menu)</small>
            )}
          </section>

          <section className={w.sec}>
            <h4>Profile</h4>
            <div className={w.grid}>
              <TextInput label="Name" placeholder="Name" withAsterisk {...userDataForm.getInputProps("name")} />
              <TextInput label="Position" placeholder="e.g. Senior researcher" {...userDataForm.getInputProps("position")} />
              <TextInput label="Email" placeholder="name@vbear.media" withAsterisk {...userDataForm.getInputProps("email")} />
              {innerProps?.mode !== "edit" && <TextInput label="Password" placeholder="Password" {...userDataForm.getInputProps("password")} />}
              {(role === "stringer" || role === "researcher" || isStaffPay) && (
                <NumberInput label="Telegram id" placeholder="Telegram id" hideControls {...userDataForm.getInputProps("telegramId")} />
              )}
              {role !== "observer" && role !== "stringer" && (
                <>
                  <TextInput label="Nickname" placeholder="nickname" icon="@" {...userDataForm.getInputProps("nickname")} />
                  <Select label="Country" placeholder="Country" data={countries} searchable {...userDataForm.getInputProps("country")} />
                </>
              )}
            </div>
          </section>

          {role && role !== "observer" && role !== "stringer" && (
            <section className={w.sec}>
              <h4>Pay</h4>
              <div className={w.grid}>
                {role === "gallery editor" ? (
                  <>
                    {/* a monthly salary; a share of gallery income can be set
                        already but is not paid yet */}
                    <NumberInput label="Base salary · month" icon="$" precision={2} step={0.01} min={0} {...userDataForm.getInputProps("baseSalary")} />
                    <NumberInput
                      label="Share of gallery income · not active yet"
                      description="Not paid yet: only the base salary is paid"
                      icon="%"
                      min={0}
                      max={100}
                      {...userDataForm.getInputProps("percentage")}
                    />
                  </>
                ) : isStaffPay ? (
                  <>
                    <NumberInput label="Monthly rate" icon="$" precision={2} step={0.01} min={0} {...userDataForm.getInputProps("videoRate")} />
                    {(role === "copyright manager" || role === "output editor") && (
                      <NumberInput label="Base salary" icon="$" precision={2} step={0.01} min={0} {...userDataForm.getInputProps("baseSalary")} />
                    )}
                  </>
                ) : (
                  <>
                    <NumberInput
                      label={role === "researcher" ? "Advance · exclusive deal" : "Advance payment"}
                      icon="$"
                      min={0}
                      {...userDataForm.getInputProps("advancePayment")}
                    />
                    {role === "researcher" && (
                      <NumberInput label="Advance · non-exclusive deal" icon="$" min={0} {...userDataForm.getInputProps("advancePaymentNonExclusive")} />
                    )}
                    <NumberInput label="Share of VBear income" icon="%" min={0} max={100} {...userDataForm.getInputProps("percentage")} />
                  </>
                )}
              </div>
              {currentMonthSalary && typeof currentMonthSalary.total === "number" && (
                <small className={w.note}>This month so far: ${currentMonthSalary.total.toFixed(2)}</small>
              )}
            </section>
          )}

          {(role === "stringer" || role === "researcher") && (
            <section className={w.sec}>
              <h4>Pay as a stringer</h4>
              <div className={w.grid}>
                <Select
                  label="Type"
                  placeholder="Not paid as a stringer"
                  data={[
                    { value: "advance", label: "Advance", disabled: role === "researcher" },
                    { value: "percentage", label: "Percentage" },
                  ]}
                  clearable
                  {...userDataForm.getInputProps("stringerPaymentType")}
                />
                {!!userDataForm.values.stringerPaymentType && (
                  <NumberInput
                    label={userDataForm.values.stringerPaymentType === "percentage" ? "Percentage" : "Advance"}
                    icon={userDataForm.values.stringerPaymentType === "percentage" ? "%" : "$"}
                    hideControls
                    min={0}
                    max={userDataForm.values.stringerPaymentType === "percentage" ? 100 : 10000}
                    {...userDataForm.getInputProps("stringerPaymentValue")}
                  />
                )}
              </div>
            </section>
          )}

          {(role === "stringer" || role === "researcher") && (
            <section className={w.sec}>
              <h4>Payment details</h4>
              <div className={w.roles}>
                {[["", "Not set"], ...paymentVariants.map((x) => [x.value, x.label])].map(([k, label]) => (
                  <button
                    type="button"
                    key={k || "none"}
                    className={clsx((userDataForm.values.paymentMethod || "") === k && w.roleOn)}
                    onClick={() => userDataForm.setFieldValue("paymentMethod", k)}
                  >
                    {label}
                  </button>
                ))}
              </div>
              {userDataForm.values.paymentMethod === "bankTransfer" && (
                <div className={w.grid}>
                  <TextInput label="Full name" withAsterisk {...userDataForm.getInputProps("fullNameBankTransfer")} />
                  <TextInput label="Bank name" withAsterisk {...userDataForm.getInputProps("bankNameBankTransfer")} />
                  <TextInput className={w.wide} label="IBAN / account number" withAsterisk {...userDataForm.getInputProps("accountNumberBankTransfer")} />
                  <TextInput label="Email" withAsterisk {...userDataForm.getInputProps("emailBankTransfer")} />
                  <NumberInput label="Phone number" withAsterisk hideControls {...userDataForm.getInputProps("phoneBankTransfer")} />
                  <TextInput label="Address" withAsterisk {...userDataForm.getInputProps("addressBankTransfer")} />
                  <TextInput label="Zip code" withAsterisk {...userDataForm.getInputProps("zipCodeBankTransfer")} />
                  <TextInput className={w.wide} label="Additional information" {...userDataForm.getInputProps("AdditionalInformation")} />
                </div>
              )}
              {userDataForm.values.paymentMethod === "payPal" && (
                <div className={w.grid}>
                  <TextInput label="PayPal email" withAsterisk {...userDataForm.getInputProps("payPalEmail")} />
                </div>
              )}
              {userDataForm.values.paymentMethod === "other" && (
                <div className={w.grid}>
                  <TextInput className={w.wide} label="Payment details" withAsterisk {...userDataForm.getInputProps("textFieldOther")} />
                </div>
              )}
            </section>
          )}

          {role === "researcher" && (
            <section className={w.sec}>
              <h4>Upline researcher</h4>
              <div className={w.grid}>
                <Select
                  className={w.wide}
                  label="Gets a commission from this researcher’s deals"
                  placeholder="Nobody"
                  data={researchers.filter((r) => r.value !== innerProps?.userData?._id)}
                  clearable
                  searchable
                  {...userDataForm.getInputProps("uplineResearcher")}
                />
                {userDataForm.values.uplineResearcher && (
                  <>
                    <NumberInput label="Commission · exclusive" icon="$" precision={2} step={0.01} min={0} {...userDataForm.getInputProps("uplineResearcherComissionExclusive")} />
                    <NumberInput label="Commission · non-exclusive" icon="$" precision={2} step={0.01} min={0} {...userDataForm.getInputProps("uplineResearcherComissionNonExclusive")} />
                  </>
                )}
              </div>
            </section>
          )}

          <section className={w.sec}>
            <h4>Access</h4>
            <div className={w.toggles}>
              {(role === "stringer" || role === "researcher") && toggle("canBeAssigned", "Can be assigned", "Gets cards and videos assigned to them")}
              {role === "researcher" && toggle("nonExclusiveAcquisitionIsAllowed", "Non-exclusive deals allowed", "Can make agreements without exclusivity")}
              {toggle("displayOnTheSite", "Show on the site", "In the team list on vbear.media")}
              {role === "researcher" && toggle("mainInstagramPage", "Main Instagram page", "Posts to the main VBear Instagram")}
              {["researcher", "admin", "copyright manager", "editor", "output editor"].includes(role) &&
                toggle("canSeeAllVideosInTrello", "Sees all videos", "Not only their own cards in the pipeline")}
            </div>
          </section>

          {role === "researcher" && (
            <section className={w.sec}>
              <h4>Rights permissions</h4>
              <div className={w.toggles}>
                {toggle("skipRights", "Can skip the consent step", "Skip button on Douyin videos: the card goes straight to Ready to upload")}
                {userDataForm.values.skipRights &&
                  toggle("skipRightsAnyLink", "Skip for any link", "Not only Douyin: TikTok, Instagram, YouTube and others")}
                {toggle(
                  "autoApproveNonExclusive",
                  "Auto-approve non-exclusive deals",
                  "A text permission that passes the AI check goes to upload without the copyright manager"
                )}
              </div>
            </section>
          )}
        </div>

        <div className={w.foot}>
          <button type="button" className={w.ghost} onClick={close}>
            Cancel
          </button>
          <button type="submit" className={w.primary} disabled={isLoading}>
            {isLoading ? "Saving…" : innerProps?.mode === "create" ? "Add worker" : "Save changes"}
          </button>
        </div>
      </form>
    );
  }

  return (
    <form
      className={styles.editWorkerForm}
      onSubmit={userDataForm.onSubmit((values) => toCreateOrUpdateUser(values))}
    >
      <Grid
        gutter="lg"
        grow
        columns={12}
        className={clsx([styles.formGridBlock, styles.main])}
      >
        {innerProps?.role === "company" ? (
          <>
            <Grid.Col span={12}>
              <TextInput
                placeholder="Company name"
                label="Company name"
                withAsterisk
                {...userDataForm.getInputProps("name")}
              />
            </Grid.Col>
            <Grid.Col span={12}>
              <TextInput
                label="Email"
                withAsterisk
                {...userDataForm.getInputProps("email")}
              />
            </Grid.Col>
            {innerProps?.mode !== "edit" && (
              <Grid.Col span={12}>
                <TextInput
                  label="Password"
                  type="password"
                  withAsterisk
                  {...userDataForm.getInputProps("password")}
                />
              </Grid.Col>
            )}

            <Grid.Col span={6}>
              <NumberInput
                placeholder="Percentage"
                label="Percentage"
                {...userDataForm.getInputProps("percentage")}
                icon="%"
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <Select
                label="Payment Method"
                placeholder="Select payment method"
                data={[
                  { value: "payPal", label: "PayPal" },
                  { value: "bankTransfer", label: "Bank Transfer" },
                  { value: "other", label: "Other" },
                ]}
                {...userDataForm.getInputProps("paymentMethod")}
              />
            </Grid.Col>
            {userDataForm.values.paymentMethod === "payPal" && (
              <Grid.Col span={12}>
                <TextInput
                  label="PayPal Email"
                  placeholder="Enter your PayPal email"
                  {...userDataForm.getInputProps("payPalEmail")}
                />
              </Grid.Col>
            )}
            {userDataForm.values.paymentMethod === "bankTransfer" && (
              <>
                <Grid.Col span={6}>
                  <TextInput
                    label="Phone"
                    placeholder="Enter your phone number"
                    {...userDataForm.getInputProps("phoneBankTransfer")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Email"
                    placeholder="Enter your email"
                    {...userDataForm.getInputProps("emailBankTransfer")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Address"
                    placeholder="Enter your address"
                    {...userDataForm.getInputProps("addressBankTransfer")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Zip Code"
                    placeholder="Enter your zip code"
                    {...userDataForm.getInputProps("zipCodeBankTransfer")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Bank Name"
                    placeholder="Enter your bank name"
                    {...userDataForm.getInputProps("bankNameBankTransfer")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Full Name"
                    placeholder="Enter your full name"
                    {...userDataForm.getInputProps("fullNameBankTransfer")}
                  />
                </Grid.Col>
                <Grid.Col span={6}>
                  <TextInput
                    label="Account Number"
                    placeholder="Enter your account number"
                    {...userDataForm.getInputProps("accountNumberBankTransfer")}
                  />
                </Grid.Col>
              </>
            )}
            {userDataForm.values.paymentMethod === "other" && (
              <Grid.Col span={12}>
                <TextInput
                  label="Other Payment Method Details"
                  placeholder="Enter details for the other payment method"
                  {...userDataForm.getInputProps("textFieldOther")}
                />
              </Grid.Col>
            )}
          </>
        ) : (
          <>
            {(userDataForm.values.role !== "author" ||
              (userDataForm.values.role === "author" &&
                innerProps?.mode === "create")) && (
              <>
                <Grid.Col span={12} className={styles.gridCol}>
                  <Select
                    data={roleVariants}
                    placeholder="Role"
                    label="Role"
                    {...userDataForm.getInputProps("role")}
                    dropdownPosition="bottom"
                  />
                </Grid.Col>
                <Grid.Col span={6} className={styles.gridCol}>
                  <TextInput
                    placeholder="Position"
                    label="Position"
                    {...userDataForm.getInputProps("position")}
                  />
                </Grid.Col>
              </>
            )}
            <Grid.Col span={6} className={styles.gridCol}>
              <TextInput
                placeholder="Name"
                label="Name"
                withAsterisk
                {...userDataForm.getInputProps("name")}
              />
            </Grid.Col>
            <Grid.Col span={6} className={styles.gridCol}>
              <TextInput
                placeholder="Email"
                label="Email"
                withAsterisk
                {...userDataForm.getInputProps("email")}
              />
            </Grid.Col>

            {(userDataForm.values.role === "stringer" ||
              userDataForm.values.role === "researcher" ||
              userDataForm.values.role === "editor" ||
              userDataForm.values.role === "copyright manager" ||
              userDataForm.values.role === "output editor") && (
              <Grid.Col span={6} className={styles.gridCol}>
                <NumberInput
                  label="Telegram id"
                  placeholder="Telegram id"
                  {...userDataForm.getInputProps("telegramId")}
                  hideControls
                />
              </Grid.Col>
            )}

            {innerProps?.mode !== "edit" &&
              userDataForm.values.role !== "author" && (
                <Grid.Col span={6} className={styles.gridCol}>
                  <TextInput
                    placeholder="Password"
                    label="Password"
                    {...userDataForm.getInputProps("password")}
                  />
                </Grid.Col>
              )}
            {userDataForm.values.role !== "author" &&
              userDataForm.values.role !== "observer" &&
              userDataForm.values.role !== "stringer" && (
                <>
                  <Grid.Col span={6} className={styles.gridCol}>
                    <TextInput
                      placeholder="Nickname"
                      label="Nickname"
                      {...userDataForm.getInputProps("nickname")}
                      icon="@"
                    />
                  </Grid.Col>
                  
                  {userDataForm.values.role === "editor" || userDataForm.values.role === "copyright manager" || userDataForm.values.role === "output editor" ? (
                    <>
                      <Grid.Col span={6} className={styles.gridCol}>
                        <NumberInput
                          placeholder="Monthly rate"
                          label="Monthly rate"
                          {...userDataForm.getInputProps("videoRate")}
                          icon="$"
                          precision={2}
                          step={0.01}
                          min={0}
                        />
                      </Grid.Col>
                      {(userDataForm.values.role === "copyright manager" || userDataForm.values.role === "output editor") && (
                        <Grid.Col span={6} className={styles.gridCol}>
                          <NumberInput
                            placeholder="Base salary"
                            label="Base salary"
                            {...userDataForm.getInputProps("baseSalary")}
                            icon="$"
                            precision={2}
                            step={0.01}
                            min={0}
                          />
                        </Grid.Col>
                      )}
                    </>
                  ) : (
                    <>
                      <Grid.Col span={6} className={styles.gridCol}>
                        <NumberInput
                          placeholder={
                            userDataForm.values.role === "researcher"
                              ? "Advance payment exclusive"
                              : "Advance payment"
                          }
                          label={
                            userDataForm.values.role === "researcher"
                              ? "Advance payment exclusive"
                              : "Advance payment"
                          }
                          {...userDataForm.getInputProps("advancePayment")}
                          icon="$"
                        />
                      </Grid.Col>
                      {userDataForm.values.role === "researcher" && (
                        <Grid.Col span={6} className={styles.gridCol}>
                          <NumberInput
                            placeholder="Advance payment non-exclusive"
                            label="Advance payment non-exclusive"
                            {...userDataForm.getInputProps(
                              "advancePaymentNonExclusive"
                            )}
                            icon="$"
                          />
                        </Grid.Col>
                      )}
                      <Grid.Col span={6} className={styles.gridCol}>
                        <NumberInput
                          placeholder="Percentage"
                          label="Percentage"
                          {...userDataForm.getInputProps("percentage")}
                          icon="%"
                        />
                      </Grid.Col>
                    </>
                  )}
                  
                  <Grid.Col
                    span={6}
                    className={clsx([styles.gridCol, styles.marginBottomLg])}
                  >
                    <Select
                      data={countries}
                      searchable
                      placeholder="Country"
                      label="Country"
                      {...userDataForm.getInputProps("country")}
                    />
                  </Grid.Col>
                </>
              )}

            {(userDataForm.values.role === "stringer" ||
              userDataForm.values.role === "researcher") && (
              <Grid.Col
                span={12}
                className={clsx([styles.gridCol, styles.marginBottomLg])}
              >
                <Grid
                  gutter="lg"
                  grow
                  columns={12}
                  className={clsx([styles.formGridBlock, styles.paymentInfo])}
                >
                  <Grid.Col
                    span={!userDataForm.values.stringerPaymentType ? 12 : 6}
                    className={styles.gridCol}
                  >
                    <Select
                      w="100%"
                      placeholder="Stringer payment type"
                      data={[
                        {
                          value: "advance",
                          label: "Advance",
                          disabled: Boolean(
                            userDataForm.values.role === "researcher"
                          ),
                        },
                        { value: "percentage", label: "Percentage" },
                      ]}
                      {...userDataForm.getInputProps("stringerPaymentType")}
                      clearable
                      dropdownPosition="bottom"
                    />
                  </Grid.Col>

                  {!!userDataForm.values.stringerPaymentType && (
                    <Grid.Col span={6} className={styles.gridCol}>
                      <NumberInput
                        icon={
                          userDataForm.values.stringerPaymentType ===
                          "percentage"
                            ? "%"
                            : "$"
                        }
                        placeholder={
                          userDataForm.values.stringerPaymentType ===
                          "percentage"
                            ? "Percentage value"
                            : "Advance value"
                        }
                        {...userDataForm.getInputProps("stringerPaymentValue")}
                        hideControls
                        min={0}
                        max={
                          userDataForm.values.stringerPaymentType ===
                          "percentage"
                            ? 100
                            : 10000
                        }
                      />
                    </Grid.Col>
                  )}
                </Grid>
              </Grid.Col>
            )}

            {(userDataForm.values.role === "stringer" ||
              userDataForm.values.role === "researcher" ||
              userDataForm.values.role === "author") && (
              <Grid.Col
                span={12}
                className={clsx([styles.gridCol, styles.marginBottomLg])}
              >
                <Grid
                  gutter="lg"
                  grow
                  columns={12}
                  className={clsx([styles.formGridBlock, styles.paymentInfo])}
                >
                  <Grid.Col span={12} className={styles.gridCol}>
                    <Select
                      placeholder="Choose payment method"
                      data={paymentVariants}
                      {...userDataForm.getInputProps("paymentMethod")}
                      clearable
                      dropdownPosition="bottom"
                    />
                  </Grid.Col>
                  {userDataForm.values.paymentMethod === "bankTransfer" && (
                    <>
                      <Grid.Col span={6} className={styles.gridCol}>
                        <NumberInput
                          withAsterisk
                          placeholder="Phone number"
                          label="Phone number"
                          hideControls
                          {...userDataForm.getInputProps("phoneBankTransfer")}
                        />
                      </Grid.Col>
                      <Grid.Col span={6} className={styles.gridCol}>
                        <TextInput
                          withAsterisk
                          placeholder="Email"
                          label="Email"
                          {...userDataForm.getInputProps("emailBankTransfer")}
                        />
                      </Grid.Col>
                      <Grid.Col span={6} className={styles.gridCol}>
                        <TextInput
                          withAsterisk
                          placeholder="Address"
                          label="Address"
                          {...userDataForm.getInputProps("addressBankTransfer")}
                        />
                      </Grid.Col>
                      <Grid.Col span={6} className={styles.gridCol}>
                        <TextInput
                          withAsterisk
                          placeholder="Zip code"
                          label="Zip code"
                          {...userDataForm.getInputProps("zipCodeBankTransfer")}
                        />
                      </Grid.Col>
                      <Grid.Col span={6} className={styles.gridCol}>
                        <TextInput
                          withAsterisk
                          placeholder="Bank name"
                          label="Bank name"
                          {...userDataForm.getInputProps(
                            "bankNameBankTransfer"
                          )}
                        />
                      </Grid.Col>
                      <Grid.Col span={6} className={styles.gridCol}>
                        <TextInput
                          withAsterisk
                          placeholder="Full name"
                          label="Full name"
                          {...userDataForm.getInputProps(
                            "fullNameBankTransfer"
                          )}
                        />
                      </Grid.Col>
                      <Grid.Col span={12} className={styles.gridCol}>
                        <TextInput
                          withAsterisk
                          placeholder="IBAN"
                          label="IBAN"
                          {...userDataForm.getInputProps(
                            "accountNumberBankTransfer"
                          )}
                        />
                      </Grid.Col>
                      <Grid.Col span={12} className={styles.gridCol}>
                        <TextInput
                          placeholder="Additional information"
                          label="AdditionalInformation"
                          {...userDataForm.getInputProps(
                            "AdditionalInformation"
                          )}
                        />
                      </Grid.Col>
                    </>
                  )}
                  {userDataForm.values.paymentMethod === "payPal" && (
                    <Grid.Col span={6} className={styles.gridCol}>
                      <TextInput
                        withAsterisk
                        placeholder="PayPal email"
                        label="PayPal email"
                        {...userDataForm.getInputProps("payPalEmail")}
                      />
                    </Grid.Col>
                  )}
                  {userDataForm.values.paymentMethod === "other" && (
                    <Grid.Col span={6} className={styles.gridCol}>
                      <TextInput
                        withAsterisk
                        placeholder="Payment data is arbitrary"
                        label="Payment data is arbitrary"
                        {...userDataForm.getInputProps("textFieldOther")}
                      />
                    </Grid.Col>
                  )}
                </Grid>
              </Grid.Col>
            )}

            {(userDataForm.values.role === "stringer" ||
              userDataForm.values.role === "researcher") && (
              <Grid.Col
                span={12}
                className={clsx([styles.gridCol, styles.marginBottomXs])}
              >
                <Checkbox
                  label="Can be assigned"
                  {...userDataForm.getInputProps("canBeAssigned")}
                  checked={userDataForm.values.canBeAssigned}
                  color="cyan"
                />
              </Grid.Col>
            )}
            {userDataForm.values.role === "researcher" && (
              <Grid.Col
                span={12}
                className={clsx([styles.gridCol, styles.marginBottomXs])}
              >
                <Checkbox
                  label="Non-exclusive acquisition is allowed?"
                  {...userDataForm.getInputProps("nonExclusiveAcquisitionIsAllowed")}
                  checked={userDataForm.values.nonExclusiveAcquisitionIsAllowed}
                  color="cyan"
                />
              </Grid.Col>
            )}
            {userDataForm.values.role !== "author" && (
              <Grid.Col
                span={12}
                mt="sm"
                className={clsx([styles.gridCol, styles.marginBottomXs])}
              >
                <Checkbox
                  label="Display on the site"
                  {...userDataForm.getInputProps("displayOnTheSite")}
                  checked={userDataForm.values.displayOnTheSite}
                  color="cyan"
                />
              </Grid.Col>
            )}
            {userDataForm.values.role === "researcher" && (
              <>
                <Grid.Col
                  span={12}
                  mt="sm"
                  className={clsx([styles.gridCol, styles.marginBottomXs])}
                >
                  <Checkbox
                    label="Main Instagram Page"
                    {...userDataForm.getInputProps("mainInstagramPage")}
                    checked={userDataForm.values.mainInstagramPage}
                    color="cyan"
                  />
                </Grid.Col>
                
                {/* Upline Researcher Section */}
                <Grid.Col
                  span={12}
                  className={clsx([styles.gridCol, styles.marginBottomLg])}
                >
                  <Grid
                    gutter="lg"
                    grow
                    columns={12}
                    className={clsx([styles.formGridBlock, styles.paymentInfo])}
                  >
                    <Grid.Col span={12} className={styles.gridCol}>
                      <Select
                        placeholder="Select upline researcher"
                        label="Upline Researcher"
                        data={researchers}
                        {...userDataForm.getInputProps("uplineResearcher")}
                        clearable
                        searchable
                        dropdownPosition="bottom"
                      />
                    </Grid.Col>
                    
                    {userDataForm.values.uplineResearcher && (
                      <>
                        <Grid.Col span={6} className={styles.gridCol}>
                          <NumberInput
                            placeholder="Upline researcher commission exclusive"
                            label="Upline Researcher Commission Exclusive"
                            {...userDataForm.getInputProps("uplineResearcherComissionExclusive")}
                            icon="$"
                            precision={2}
                            step={0.01}
                            min={0}
                          />
                        </Grid.Col>
                        <Grid.Col span={6} className={styles.gridCol}>
                          <NumberInput
                            placeholder="Upline researcher commission non-exclusive"
                            label="Upline Researcher Commission Non-Exclusive"
                            {...userDataForm.getInputProps("uplineResearcherComissionNonExclusive")}
                            icon="$"
                            precision={2}
                            step={0.01}
                            min={0}
                          />
                        </Grid.Col>
                      </>
                    )}
                  </Grid>
                </Grid.Col>
              </>
            )}
            {(userDataForm.values.role === "researcher" || 
              userDataForm.values.role === "admin" || 
              userDataForm.values.role === "copyright manager" || 
              userDataForm.values.role === "editor" ||
              userDataForm.values.role === "output editor") && (
              <Grid.Col
                span={12}
                mt="sm"
                className={clsx([styles.gridCol, styles.marginBottomLg])}
              >
                <Checkbox
                  label="Can see all videos in trello"
                  {...userDataForm.getInputProps("canSeeAllVideosInTrello")}
                  checked={userDataForm.values.canSeeAllVideosInTrello}
                  color="cyan"
                />
              </Grid.Col>
            )}
          </>
        )}
        <Grid.Col span={12} className={styles.gridCol}>
          <Group position="apart" w="100%">
            <Button
              disabled={isLoading}
              color="grape"
              type="submit"
              className={styles.saveBtn}
              loading={isLoading}
            >
              {innerProps?.mode === "create" ? "Create" : "Save"}
            </Button>
            
            {innerProps?.mode === "edit" && innerProps?.userData && innerProps?.userData?.role === "author" && (
              <Button
                color="red"
                onClick={() => {
                  modals.openConfirmModal({
                    title: "Delete Author",
                    centered: true,
                    children: (
                      <Text size="sm">
                        Are you sure you want to delete this author {innerProps.userData.email}?
                      </Text>
                    ),
                    labels: { confirm: "Delete", cancel: "Cancel" },
                    confirmProps: { color: "red" },
                    onConfirm: async () => {
                      try {
                        const { data } = await axiosInstance.patch(
                          `/users/updateOne`,
                          { inTheArchive: true },
                          {
                            params: {
                              userId: innerProps.userData._id,
                            },
                          }
                        );
                        
                        if (data.status === "success") {
                          toast.success("Author archived successfully");
                          if (innerProps?.onTrigger) {
                            innerProps.onTrigger();
                          }
                          modals.closeAll();
                        } else {
                          toast.error(data.message || "Failed to archive author");
                        }
                      } catch (error) {
                        console.error("Error archiving author:", error);
                        toast.error(error.response?.data?.message || "An error occurred while archiving the author");
                      }
                    },
                  });
                }}
              >
                Delete author
              </Button>
            )}
          </Group>
        </Grid.Col>
      </Grid>
    </form>
  );
};

export default UserInfoModal;
